import { FC, SVGProps } from "react";

const BagIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="currentcolor" {...props}>
      <path
        d="M1.3 12C0.9425 12 0.636458 11.8763 0.381875 11.6289C0.127292 11.3816 0 11.0842 0 10.7368V3.78947C0 3.44211 0.127292 3.14474 0.381875 2.89737C0.636458 2.65 0.9425 2.52632 1.3 2.52632H3.9V1.26316C3.9 0.915789 4.02729 0.618421 4.28188 0.371053C4.53646 0.123684 4.8425 0 5.2 0H7.8C8.1575 0 8.46354 0.123684 8.71813 0.371053C8.97271 0.618421 9.1 0.915789 9.1 1.26316V2.52632H11.7C12.0575 2.52632 12.3635 2.65 12.6181 2.89737C12.8727 3.14474 13 3.44211 13 3.78947V10.7368C13 11.0842 12.8727 11.3816 12.6181 11.6289C12.3635 11.8763 12.0575 12 11.7 12H1.3ZM1.3 10.7368H11.7V3.78947H1.3V10.7368ZM5.2 2.52632H7.8V1.26316H5.2V2.52632Z"
      />
    </svg>
  );
};

export default BagIcon;
